import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Dice
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('dice')
        }

        // Resource
        this.resource = this.resources.items.cubeModel

        this.setModel()
    }

    setModel()
    {
        this.model = this.resource.scene
        this.model.scale.set(.02, .02, .02)
        this.model.position.set(0, 2, 0)
        this.scene.add(this.model)

        this.model.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.castShadow = true
            }
        })
    }

    update(time)
    {
        this.model.rotation.y = Math.sin(time.elapsed * 0.001) * Math.PI
        this.model.rotation.z = Math.cos(time.elapsed * 0.001) * Math.PI
        
        // this.model.rotation.x = Math.sin(time * Math.PI)
    }
}